/* eslint-disable react/destructuring-assignment */
import React, { FC } from 'react'
import { EditableComponent } from '@adobe/aem-react-editable-components'
import { EditableComponentPropsType } from '../../../utils/prop-types'
import { ChangeMyLocationInner } from './ChangeMyLocationInner'
import { MyLocationProps } from './types'
import { ChangeMyLocationMock } from './mocks/ChangeMyLocation.mock'

const ChangeMyLocation: FC<EditableComponentPropsType<MyLocationProps>> = (
  props
) => {
  return (
    <EditableComponent {...props}>
      {props.isInEditor ? (
        <ChangeMyLocationMock />
      ) : (
        <ChangeMyLocationInner {...props.model} />
      )}
    </EditableComponent>
  )
}

export default ChangeMyLocation
